import { render, staticRenderFns } from "./AdminCommission.vue?vue&type=template&id=6d96839f&scoped=true&"
import script from "./AdminCommission.vue?vue&type=script&lang=js&"
export * from "./AdminCommission.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommission.vue?vue&type=style&index=0&id=6d96839f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d96839f",
  null
  
)

export default component.exports